import StoreStoreStatus from './StoreStoreStatus'

export default StoreStoreStatus
